module.exports = __webpack_public_path__ + "static/media/img_changjing@2x.b8394cc7.png";